import teamReducer from './teamReducer'
import teamInstanceReducer from './teamInstanceReducer'

export default {
  teamReducer,
  teamInstanceReducer,
}
